// Module
var code = "<wt-generic-search-bar criteria=\"vm.criteria\" filtered-items=\"vm.filteredItems\" items=\"vm.items\" placeholder=\"Search for a user (u:user name, co:company, em:email)\"> </wt-generic-search-bar>";
// Exports
module.exports = code;